import { ProcessesProcessCategoryEnum } from 'generated/resources/graphql'

import { Item } from '../item'

export enum ProcessCategories {
  Custom = 'custom',
  Onboarding = 'onboarding',
  Offboarding = 'offboarding',
  Training = 'training',
}

export interface Step {
  id?: number | null
  name: string
  offsetAmount?: number | null
  offsetDirection?: string | null
  position?: number | null
  progressionCondition?: string | null
  progressionConditionResourceKey?: string | null
  createdAt: any
  items: Array<Item>
}

export interface ProcessTemplate {
  id: string
}

export interface ProcessDetail {
  validationMessage?: string | null
  validSettings?: boolean | null
  id: number
  category?: ProcessesProcessCategoryEnum | null
  description?: string | null
  name: string
  steps: Array<Step>
  template?: ProcessTemplate | null
}
